import * as React from 'react';

import {
  BouncingDot,
  BouncingLoaderWrapper,
  LoaderWrapper,
  StyledLogoWrapper,
} from './styles';
import Logo from '../../../assets/Logo';
import { ApplicationLoaderProps } from './types';

const ApplicationLoader: React.FC<ApplicationLoaderProps> = ({ withBlur }) => {
  return (
    <LoaderWrapper withBlur={withBlur}>
      <StyledLogoWrapper>
        <Logo />
      </StyledLogoWrapper>
      <BouncingLoaderWrapper>
        <BouncingDot />
        <BouncingDot delay="0.2s" />
        <BouncingDot delay="0.4s" />
      </BouncingLoaderWrapper>
    </LoaderWrapper>
  );
};

export default ApplicationLoader;
